// Alphes: opens and closes the accordions written into product descriptions.
(function () {
  function bind(root) {
    root.querySelectorAll('.product__accordion__title[data-collapsible-trigger]').forEach(function (btn) {
      if (btn.dataset.auraBound) return;
      btn.dataset.auraBound = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.product__accordion');
        var open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { bind(document); });
  new MutationObserver(function () { bind(document); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Homepage: o primeiro card dos sliders de produto alinha com o título da seção.
   O tema calcula o recuo pela largura da página (slidesOffsetBefore), o que desalinha
   o card quando a seção tem margem própria (desktop) ou dentro do editor (mobile).
   Desktop: 4 cards por linha (3 entre 990 e 1199px), sem pedaço do próximo card. */
(function () {
  if (!document.body || !document.body.classList.contains('template-index')) return;
  var desk = window.matchMedia('(min-width: 990px)');
  function fix(el) {
    var s = el.swiper;
    if (!s) return;
    var sec = el.closest('.popular-products') || el.closest('.shopify-section');
    var h = sec && sec.querySelector('.section-header, h2');
    if (!h) return;
    var off = Math.max(0, Math.round(h.getBoundingClientRect().left - el.getBoundingClientRect().left));
    var changed = s.params.slidesOffsetBefore !== off;
    s.params.slidesOffsetBefore = off;
    if (desk.matches) {
      var per = window.innerWidth >= 1200 ? 4 : 3;
      var bps = s.params.breakpoints || {};
      Object.keys(bps).forEach(function (k) {
        if (+k >= 990 && bps[k].slidesPerView) bps[k].slidesPerView = +k >= 1200 ? 4 : 3;
      });
      if (s.params.slidesPerView !== per || s.params.slidesOffsetAfter !== 0) changed = true;
      s.params.slidesPerView = per;
      s.params.slidesOffsetAfter = 0;
    }
    if (changed) s.update();
  }
  function run() {
    document.querySelectorAll('.popular-products-section .products-slider__swiper.swiper-initialized').forEach(fix);
  }
  function burst() { var n = 0, t = setInterval(function () { run(); if (++n > 40) clearInterval(t); }, 250); }
  burst();
  window.addEventListener('resize', function () { setTimeout(run, 300); });
  document.addEventListener('shopify:section:load', burst);
})();

/* aura: brinde da Decoy Light. A Halo Head Torch a A$0 (produto nao listado halo-head-torch-free-gift)
   so fica no carrinho com 2 ou mais Decoy Lights, e sempre em 1 unidade. */
(function () {
  if (window.__auraGiftGuard) return; window.__auraGiftGuard = 1;
  var DECOY = 15403892605115, GIFT = 67635061260475, busy = false, _f = window.fetch;
  function check() {
    if (busy) return; busy = true;
    _f('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var lights = 0, idx = -1, key = null, gq = 0;
      c.items.forEach(function (it, i) {
        if (it.product_id === DECOY) lights += it.quantity;
        if (it.variant_id === GIFT) { idx = i + 1; key = it.key; gq = it.quantity; }
      });
      var want = lights >= 2 ? 1 : 0;
      if (idx < 0 && want === 1) {
        var drawer = document.querySelector('cart-drawer');
        _f('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: GIFT, quantity: 1, properties: { '_gift': 'Free with The Decoy Kit' } }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) })
          .then(function (r) { return r.json(); }).then(function (j) {
            busy = false;
            if (/\/cart(\?|$)/.test(location.pathname)) { location.reload(); return; }
            if (drawer && j.sections && typeof drawer.renderContents === 'function') { try { drawer.renderContents(j); } catch (e) {} }
          }).catch(function () { busy = false; });
        return;
      }
      if (idx < 0 || gq === want) { busy = false; return; }
      var el = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
      if (el && typeof el.updateQuantity === 'function') { el.updateQuantity(idx, want); setTimeout(function () { busy = false; }, 1500); return; }
      _f('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: want }) })
        .then(function () { busy = false; if (/\/cart(\?|$)/.test(location.pathname)) location.reload(); });
    }).catch(function () { busy = false; });
  }
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _f.apply(this, arguments);
    if (/\/cart\/(change|update|clear)/.test(url)) p.then(function () { setTimeout(check, 400); }).catch(function () {});
    return p;
  };
  if (document.readyState !== 'loading') check(); else document.addEventListener('DOMContentLoaded', check);
})();

/* Lost-at-Sea Cover: carrinho com 2 pares ou mais de ColdWall Plugs grava o atributo da cobertura, que segue para o pedido. */
(function () {
  var _f = window.fetch, KEY = 'Lost-at-Sea Cover', VAL = 'Included, 12 months from delivery', HANDLE = 'alphes-coldwall-plugs';
  function sync() {
    _f('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var q = 0; (c.items || []).forEach(function (it) { if (it.handle === HANDLE) q += it.quantity; });
      var want = q >= 2 ? VAL : '', have = (c.attributes && c.attributes[KEY]) || '';
      if (want === have) return;
      var a = {}; a[KEY] = want;
      return _f('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) });
    }).catch(function () {});
  }
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _f.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url) && !/cart\/update\.js/.test(url)) p.then(function () { setTimeout(sync, 300); }).catch(function () {});
    return p;
  };
  var _x = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (/\/cart\/(add|change|clear)/.test(url || '')) this.addEventListener('load', function () { setTimeout(sync, 300); });
    return _x.apply(this, arguments);
  };
  if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
})();
